import BaseKpiStatCard from './BaseKpiStatCard.vue'
import BaseStatusProgress from './BaseStatusProgress.vue'
import BaseDonutChart from './BaseDonutChart.vue'
import BaseRankingBarChart from './BaseRankingBarChart.vue'
import BaseDistributionBarChart from './BaseDistributionBarChart.vue'
import BaseReconciliationPanel from './BaseReconciliationPanel.vue'
import BaseRulesPanel from './BaseRulesPanel.vue'
import BaseCustodyPanel from './BaseCustodyPanel.vue'
import BaseServicerPanel from './BaseServicerPanel.vue'
import BaseReportingRegistry from './BaseReportingRegistry.vue'
import BaseSplitBlock from './BaseSplitBlock.vue'
import BasePricingPanel from './BasePricingPanel.vue'
import BaseDataTableFilter from './BaseDataTableFilter.vue'
import BaseFilterBarStandalone from './BaseFilterBarStandalone.vue'
import DashboardAccordionLazyTabs from './DashboardAccordionLazyTabs.vue'
import BaseDetailDrawer from './BaseDetailDrawer.vue'
import BaseStepper from './BaseStepper.vue'
import BaseTimeline from './BaseTimeline.vue'
import BaseDropzone from './BaseDropzone.vue'
import BaseStatusPill from './BaseStatusPill.vue'
import BaseEntityBadge from './BaseEntityBadge.vue'
import BaseFigures from './BaseFigures.vue'
import BaseButtonAction from './BaseButtonAction.vue'
import DashboardSection from './DashboardSection.vue'
import DashboardGrid from './DashboardGrid.vue'
import DashboardLazyRef from './DashboardLazyRef.vue'

export default {
  kpi_stat_card: BaseKpiStatCard,
  status_progress: BaseStatusProgress,
  donut_chart: BaseDonutChart,
  ranking_bar_chart: BaseRankingBarChart,
  distribution_bar_chart: BaseDistributionBarChart,
  reconciliation_panel: BaseReconciliationPanel,
  rules_panel: BaseRulesPanel,
  custody_panel: BaseCustodyPanel,
  servicer_panel: BaseServicerPanel,
  reporting_registry: BaseReportingRegistry,
  split_block: BaseSplitBlock,
  pricing_panel: BasePricingPanel,
  data_table_filter: BaseDataTableFilter,
  filter_bar: BaseFilterBarStandalone,
  accordion_drilldown: DashboardAccordionLazyTabs,
  detail_drawer: BaseDetailDrawer,
  stepper: BaseStepper,
  timeline: BaseTimeline,
  dropzone: BaseDropzone,
  status_pill: BaseStatusPill,
  entity_badge: BaseEntityBadge,
  figures: BaseFigures,
  button: BaseButtonAction,
  section: DashboardSection,
  grid: DashboardGrid,
  lazy_ref: DashboardLazyRef
}
